import type { WorkerMessageMap } from '~/composables/useServiceWorker'
import { handleFetchedMapAssets, handleLoadAssetsProgressively, handlePing } from './handlers/map-assets'
import { createSectionsRouteMap } from './handlers/routes-sections-mapper'

type WorkerMessage = {
  [K in keyof WorkerMessageMap]: {
    type: K
    payload: WorkerMessageMap[K]
  }
}[keyof WorkerMessageMap]

self.addEventListener('message', (event: MessageEvent<WorkerMessage>) => {
  const { type, payload } = event.data

  if (type === 'mapAssetsFetched') {
    handleFetchedMapAssets(payload as WorkerMessageMap['mapAssetsFetched']).catch((error) => {
      console.error('[Service Worker] Error handling mapAssetsFetched:', error)
    })
  }

  if (type === 'createSectionsRouteMap') {
    createSectionsRouteMap(payload as WorkerMessageMap['createSectionsRouteMap']).catch((error) => {
      console.error('[Service Worker] Error handling createSectionsRouteMap:', error)
    })
  }

  if (type === 'loadAssetsProgressively') {
    handleLoadAssetsProgressively(payload as WorkerMessageMap['loadAssetsProgressively']).catch((error) => {
      console.error('[Service Worker] Error handling loadAssetsProgressively:', error)
    })
  }

  if (type === 'ping') {
    handlePing()
  }
})
